import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';



export class ZrSwitchComponent implements OnInit {

   type?: string = 'button';
   icon?: boolean = false;         // round type  usable
   disabled?: boolean = false;
   size?: string = 'md';           // lg sm
   state?: string = 'primary';     // success、warning、info、danger、accent、primary
   outline?: boolean = false;      // round type  usable
   checked?: boolean = true;
   border?: boolean = true;       // button type  usable
   radius?: string = 'sm';        // button type  usable
   shadow?: boolean = false;      // button type  usable
   text?: any[] = ['ON', 'OFF'];  // button type  usable

   checkedChange = new EventEmitter<any>();
  name: string;

  constructor() {
    this.name = String(Math.random() * 10);
  };

  ngOnInit() {
  };

  handle(event: any) {
    this.checkedChange.emit(event.target.checked);
  };

  handleButton() {
    if (this.disabled) {
      return;
    };
    this.checked = !this.checked;
    this.checkedChange.emit(this.checked);
  };
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'zr-switch',
  template: `
  <!-- round -->
  <span *ngIf="type==='round'" class="m-switch m-switch--{{state}}" [ngClass]="{'m-switch--icon':icon,'m-switch--lg':size==='lg',
    'm-switch--sm':size==='sm','m-switch--outline':outline}">
    <label>
      <input type="checkbox" name="{{name}}" [disabled]="disabled" [checked]="checked" (change)="handle($event)">
      <span></span>
    </label>
  </span>
  
  <!-- button -->
  <div *ngIf="type==='button'" class="lz-button-switch-continer" (click)="handleButton()"
      [ngClass]="{'lz-button-switch-sm':size==='sm','lz-button-switch-md':size==='md','lz-button-switch-lg':size==='lg',
      'lz-button-switch-border':border,'lz-button-switch-border-radius-sm':radius==='sm','lz-button-switch-border-radius-lg':radius==='lg',
      'lz-button-shadow':shadow}">
    <div class="lz-button-switch-contient clearfix" 
      [ngClass]="{'lz-button-switch-animate-sm-on':size==='sm'&&checked,
      'lz-button-switch-animate-sm-off':size==='sm'&&!checked,
      'lz-button-switch-animate-md-on':size==='md'&&checked,
      'lz-button-switch-animate-md-off':size==='md'&&!checked,
      'lz-button-switch-animate-lg-on':size==='lg'&&checked,
      'lz-button-switch-animate-lg-off':size==='lg'&&!checked,
      'lz-button-disabled':disabled}">
      <span class="lz-button-bg-{{state}}" [ngStyle]="{'color':'#fff'}">{{text[0]}}</span>
      <span>&ngsp;</span>
      <span [ngStyle]="{'background-color':'#ebedf2','border-color':'#ebedf2','color':'#575962'}">{{text[1]}}</span>
    </div>
  </div>
  `,
  styles: [`
    .lz-button-switch-continer {
      overflow: hidden;
      cursor: pointer;
    }
    .lz-button-switch-continer span {
      float: left;
      display: block;
    }
    
    .lz-button-switch-border {
      border: 1px solid #ebedf2;
    }
    
    .lz-button-switch-border-radius-sm {
      border-radius: 4px;
    }
    
    .lz-button-switch-border-radius-lg {
      border-radius: 25.5px;
    }
    
    .lz-button-bg-success {
      background-color: #34bfa3;
    }
    
    .lz-button-bg-warning {
      background-color: #f5b22e;
    }
    
    .lz-button-bg-info {
      background-color: #38a1f6;
    }
    
    .lz-button-bg-danger {
      background-color: #f3516d;
    }
    
    .lz-button-bg-primary {
      background-color: #5967dc;
    }
    
    .lz-button-bg-accent {
      background-color: #05c1db;
    }
    
    .lz-button-bg-brand {
      background-color: #716aca;
    }
    
    .lz-button-shadow {
      box-shadow: 0 3px 20px 0 rgba(113, 106, 202, 0.17);
    }
    
    .lz-button-disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
    
    .lz-button-switch-sm {
      width: 94px;
      height: 26px;
      text-align: center;
    }
    .lz-button-switch-sm .lz-button-switch-contient {
      width: 141px;
    }
    .lz-button-switch-sm .lz-button-switch-contient span {
      width: 47px;
      height: 26px;
      font-size: 0.85rem;
      line-height: 26px;
    }
    
    .lz-button-switch-md {
      width: 122px;
      height: 33px;
      text-align: center;
    }
    .lz-button-switch-md .lz-button-switch-contient {
      width: 183px;
    }
    .lz-button-switch-md .lz-button-switch-contient span {
      width: 61px;
      height: 33px;
      font-size: 0.85rem;
      line-height: 33px;
    }
    
    .lz-button-switch-lg {
      width: 162px;
      height: 51px;
      text-align: center;
    }
    .lz-button-switch-lg .lz-button-switch-contient {
      width: 243px;
    }
    .lz-button-switch-lg .lz-button-switch-contient span {
      width: 81px;
      height: 51px;
      font-size: 1.1rem;
      line-height: 51px;
    }
    
    @keyframes toggleAnimateSmOn {
      from {
        margin-left: -47px;
      }
      to {
        margin-left: 0;
      }
    }
    @keyframes toggleAnimateSmOff {
      from {
        margin-left: 0;
      }
      to {
        margin-left: -47px;
      }
    }
    @keyframes toggleAnimateMdOn {
      from {
        margin-left: -61px;
      }
      to {
        margin-left: 0;
      }
    }
    @keyframes toggleAnimateMdOff {
      from {
        margin-left: 0;
      }
      to {
        margin-left: -61px;
      }
    }
    @keyframes toggleAnimateLgOn {
      from {
        margin-left: -81px;
      }
      to {
        margin-left: 0;
      }
    }
    @keyframes toggleAnimateLgOff {
      from {
        margin-left: 0;
      }
      to {
        margin-left: -81px;
      }
    }
    .lz-button-switch-animate-sm-on {
      animation: toggleAnimateSmOn 0.5s forwards;
    }
    
    .lz-button-switch-animate-sm-off {
      animation: toggleAnimateSmOff 0.5s forwards;
    }
    
    .lz-button-switch-animate-md-on {
      animation: toggleAnimateMdOn 0.5s forwards;
    }
    
    .lz-button-switch-animate-md-off {
      animation: toggleAnimateMdOff 0.5s forwards;
    }
    
    .lz-button-switch-animate-lg-on {
      animation: toggleAnimateLgOn 0.5s forwards;
    }
    
    .lz-button-switch-animate-lg-off {
      animation: toggleAnimateLgOff 0.5s forwards;
    }
  `]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'type': [{ type: Input },],
'icon': [{ type: Input },],
'disabled': [{ type: Input },],
'size': [{ type: Input },],
'state': [{ type: Input },],
'outline': [{ type: Input },],
'checked': [{ type: Input },],
'border': [{ type: Input },],
'radius': [{ type: Input },],
'shadow': [{ type: Input },],
'text': [{ type: Input },],
'checkedChange': [{ type: Output },],
};
};

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
